export const appConfig = {
  name: 'GymBRO',
  version: '0.0.1',
  year: 2025,
  author: 'NGDF',
  copyrightText: '© 2025 GymBRO. Todos los derechos reservados.'
}; 